// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 695) return "static/chunks/695-21ebfe2434908618.js";
	if (chunkId === 644) return "static/chunks/644-179636f7bb39f17f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"420c95d6c17016b1","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"48a14cf7bdb661d5","367":"b2f79687f8901759","639":"cf9d73bb0d566e4a","748":"486011c012fb0cee"}[chunkId] + ".js";
};